import { css, cx, etiColors } from '@eti/styles';
import { constants } from '@eti/utils';
import Icon from '../icon/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  ADULT,
  CHILD,
  INFANT
} = constants.ageTypes;
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const travelerDescriptionStyles = css`
  align-items: center;
  color: ${etiColors.black};
  display: flex;
`;
const getClassNames = className => cx('etiTravelerDescription', travelerDescriptionStyles, className);
const getIconId = type => {
  switch (type) {
    case CHILD:
      return 'child-traveler';
    case INFANT:
      return 'infant-traveler';
    case ADULT:
    default:
      return 'adult-traveler';
  }
};
const nameStyles = css`
  font-size: 0.875rem;
  margin-right: 5px;
`;
const descriptionStyles = css`
  font-size: 0.75rem;
`;
const iconWrapperStyles = css`
  line-height: 0;
`;
const iconStyles = css`
  fill: #aaa;
  height: 1rem;
  margin-right: 0.625rem;
  width: 1rem;

  [dir='rtl'] & {
    margin-left: 0.625rem;
    margin-right: 0;
  }
`;
const TravelerDescription = _ref => {
  let {
    className = '',
    customStyles = {
      description: '',
      icon: '',
      name: ''
    },
    description,
    name,
    shouldShowIcon,
    type = ADULT
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: getClassNames(className),
    children: [shouldShowIcon && type && /*#__PURE__*/_jsx("div", {
      className: iconWrapperStyles,
      children: /*#__PURE__*/_jsx(Icon, {
        className: cx(iconStyles, customStyles === null || customStyles === void 0 ? void 0 : customStyles.icon),
        id: getIconId(type)
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("span", {
        className: cx(customStyles === null || customStyles === void 0 ? void 0 : customStyles.name, nameStyles, MOUSE_FLOW_CLASS_NAMES),
        children: name
      }), /*#__PURE__*/_jsx("span", {
        className: cx(customStyles === null || customStyles === void 0 ? void 0 : customStyles.description, descriptionStyles),
        children: description
      })]
    })]
  });
};
export default TravelerDescription;
//# sourceMappingURL=TravelerDescription.js.map